import { DialogType } from '../../admin/AdminEventUsers/useAdminEventUsers';
import { User } from '../../apollo/__generated__/graphql';
import { useCurrentEventQuery } from './useCurrentEventQuery';
import { useUpdateUserCautionMutation } from './useUpdateUserCautionMutation';

export const useUpdateCaution = (
  setDialog: (disalog: DialogType | null) => void,
) => {
  const { data: currentEventData } = useCurrentEventQuery();

  const { updateUserCaution } = useUpdateUserCautionMutation();

  const onCautionPress = (
    user: Pick<User, 'id' | 'firstname' | 'lastname' | 'hasCaution'>,
  ) => {
    const eventId = currentEventData?.currentEvent?.id ?? null;
    if (!eventId) {
      return;
    }
    if (user.hasCaution) {
      setDialog({
        title: 'Supprimer la caution',
        description: `Êtes-vous sûr de vouloir supprimer la caution de ${user.firstname} ${user.lastname} ?`,
        onSubmit: () => {
          updateUserCaution({
            eventId,
            hasCaution: false,
            userId: user.id,
          });
          setDialog(null);
        },
      });
    } else {
      updateUserCaution({
        eventId,
        hasCaution: true,
        userId: user.id,
      });
    }
  };

  return { onCautionPress };
};
